import { render, staticRenderFns } from "./BidView.vue?vue&type=template&id=3e031874&scoped=true&"
import script from "./BidView.vue?vue&type=script&lang=js&"
export * from "./BidView.vue?vue&type=script&lang=js&"
import style0 from "./BidView.vue?vue&type=style&index=0&id=3e031874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e031874",
  null
  
)

export default component.exports